export enum AgoraVideoEncoding {
    Ve720p1 = "720p_1",
    Ve480p1 = "480p_1",
    Ve1080p1 = "1080p_1",
    Ve120p1 = "120p_1"
}